import api from '../../apiConfig/apiConfig';
import { Get, Post } from '../base/baseAjax';
function getRecordInfo(param){
	return Post({
		url:api.accessrecord.getInquCusinfo,
		bodyParam:param,
	})
}
function getRecordDetail(param, serviceSiteId) {
    return Post({
        url: api.accessrecord.getaccessrecordPageList,
        bodyParam: param,
        config: {
            timeout: 60000,
        },
        PathParam: {
            serviceSiteId: serviceSiteId,
        },
    });
}
function downloadwebsitevisit(params, serviceSiteId) {
	return Post({
		url: api.accessrecord.downloadwebsitevisit,
		bodyParam: params,
		config: {
			timeout: 60000,
			responseType: 'blob',
		},
        PathParam: {
            serviceSiteId: serviceSiteId,
        },
	});
}
function countryList() {
    return Get({
        url: api.customer.countryList,
    })
}
export default {
	getRecordInfo,
    getRecordDetail,
    downloadwebsitevisit,
    countryList
};